<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">通讯录</a></li>
                <li><a href="#">批量导入</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle"><span>批量导入</span></div>
            <div class="formtext">导入文件有一定的格式规范，样例为: <a href="https://www.2office.cn/csvsample.csv">Excel样例</a> , <a href="https://www.2office.cn/vcardsample.vcf">Vcard样例</a> </div>
            <ul class="forminfo">
    
                <li><label>分组选择</label>
                <div class="vocation">
                    <el-select v-model="txlGroupValue" placeholder="请选择">
                        <el-option
                        v-for="item in txlGroupList"
                        :key="item.groupid"
                        :label="item.groupname"
                        :value="item.groupid">
                        </el-option>
                    </el-select>
                </div>
                </li>
                
                <li style="width: 300px;">
                    <label>导入文件</label>
                    <el-upload
                        class="upload-demo"
                        :on-success="uploadSuccess"
                        ref="upload"
                        :action=uploadUrl
                        :before-upload="beforeAvatarUpload"
                        :on-change="txlFileChange"
                        :auto-upload="false"
                        :limit="1"
                        :data="fileUploadParams"
                        :headers="uploadHeaders"
                        :on-exceed="handleTxlExceed">
                        <el-button size="small" type="primary" round>选取文件</el-button>
                    </el-upload>
                    <div slot="tip" class="el-upload__tip">只能上传csv/vcf文件，且不超过500kb</div>
                </li>
                
                <li><label>&nbsp;</label><input name="" type="button" class="btn" @click="submitUpload" value="确认保存"/></li>
                
            </ul>
        </div>
        
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            //通讯录组
            txlGroupList:[],
            txlGroupValue:'',
            uploadUrl: this.GLOBAL.serverSrc + "/txl/uploadtxlfile.json",
            fileUploadParams:{'groupid':''},
            uploadHeaders:{'token':''},
            uploadips:'',
            fileList:[],
        }
    },
    mounted(){
        // this.uploadHeaders.token = this.GLOBAL.token;
        this.getTxlGroupList();
    },
    methods:{
        getTxlGroupList(){
            var that = this
            let data = {'groupid':''}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/gettxlgroup.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlGroupList = res.data.txlGroupList
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        handleTxlExceed() {
            this.$message.error("只能上传一份文件，修改请先删除。");
        },
        beforeAvatarUpload(file) {
            let Xls = file.name.split('.');
            if(Xls[1] === 'csv'||Xls[1] === 'vcf'){
                return file
            }else {
                this.$message.error('上传文件只能是 csv/vcf 格式!')
                return false;
            }
        },
        submitUpload(){
            if(this.txlGroupValue == '')
            {
                this.$message.error("请选择上传分组")
                return false;
            }
            this.fileUploadParams.groupid = this.txlGroupValue;
            this.uploadHeaders.token = this.GLOBAL.token
            this.$refs.upload.submit()
        },
        uploadSuccess(response) {
            if('0000000' == response.code)
            {
                alert("文件上传成功！")
            }
            else
            {
                alert(response.msg);
            }
        },
        txlFileChange(file) {
            if(file)
            {
                this.$message.success("选择文件成功!")
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/txl/txlupload.vue